import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { buildSupportMailto } from "utils/supportMailto";
import styles from "./GlobalErrorView.module.css";

function GlobalErrorView({ error, errorInfo }) {
  let userInfo = null;
  let clientId = null;

  try {
    // useSelector will work as long as a Redux Provider is an ancestor.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    userInfo = useSelector((state) => state.common?.user_information);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    clientId = useSelector((state) => state.common?.clientId);
  } catch {
    // Redux store unavailable – fall back to localStorage values
  }

  const mailtoHref = useMemo(
    () => buildSupportMailto({ userInfo, clientId, error, errorInfo, includeError: true }),
    [userInfo, clientId, error, errorInfo]
  );

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleReturnHome = () => {
    window.location.href = "/";
  };

  return (
    <div className={styles.errorPage}>
      <div className={styles.errorContainer}>
        <div className={styles.iconWrapper}>
          <div className={styles.icon}>
            <i className="fa-solid fa-circle-exclamation"></i>
          </div>
        </div>

        <h1 className={styles.title}>Something went wrong</h1>

        <p className={styles.description}>
          We ran into an issue and couldn't complete your request.
        </p>

        <div className={styles.actions}>
          <button
            className={`${styles.btn} ${styles.btnPrimary}`}
            onClick={handleRefresh}
          >
            Refresh Page
          </button>
          <button
            className={`${styles.btn} ${styles.btnSecondary}`}
            onClick={handleReturnHome}
          >
            Return to Home Page
          </button>
        </div>

        <div className={styles.supportLink}>
          Need help?{" "}
          <a href={mailtoHref}>Contact Support</a>
        </div>
      </div>
    </div>
  );
}

export default GlobalErrorView;
